import React from "react"
import { twMerge } from "tailwind-merge"
import { StaticImage } from "gatsby-plugin-image"
import { H2, H5, P } from "../el/typography"
import { PageButton, PillLink } from "../el/button"
import { Block, Section } from "../ui/mastercard"
import googleTag from "../googleTag"
/*
<SectionCTA
    [[normal, snug, tight], [white, light, dark]]
    pill="New for 2020"
    to="/rc"
    button={`Visit ${logo.siteMetadata.brand.rc}`}
>
  text and what not.....
</SectionCTA>
*/

const tag = () => {
  googleTag("contactCTA")
}

const SectionCTA = props => {
  return (
    <div
      className={twMerge([
        "relative mx-auto px-4 sm:px-6 lg:px-8",
        props.theme === "whitefull" && "bg-slate-50",
        props.theme === "lightfull" && "bg-slate-200",
        props.theme === "darkfull" && "bg-slate-900",
        props.normal && "py-5 sm:pb-10 sm:pt-8 xl:pb-12 xl:pt-10",
        props.snug && "py-3 sm:pb-6 sm:pt-4 xl:pb-10 xl:pt-8",
        props.tight && "py-0 sm:py-0 xl:py-0",
      ])}
    >
      <div className="mx-auto max-w-md lg:max-w-5xl">
        <div className="rounded-lg bg-slate-100 px-6 py-8 sm:p-10 lg:flex lg:items-center">
          <div className="flex-1">
            <div>
              <PillLink
                to={props.to}
                color={props.pillcolor}
                className="px-4 py-1 text-sm font-semibold uppercase"
              >
                {props.pill}
              </PillLink>
            </div>
            <div className="mt-4 text-lg leading-7 text-slate-600">
              {props.children}
            </div>
          </div>
          <div className="mt-6 rounded-md shadow lg:ml-10 lg:mt-0 lg:shrink-0">
            <PageButton white to={props.to}>
              {props.button}
            </PageButton>
          </div>
        </div>
      </div>
    </div>
  )
}

const ContactCTA = props => {
  return (
    <Block theme="darkfull">
      <Section theme="darkfull" general noheader grid gap>
        <div className="-mx-4 h-56 w-auto overflow-hidden bg-blue-600 sm:-mx-6 sm:h-72 md:col-span-4 md:h-full lg:-ml-8 lg:mr-0 xl:ml-0">
          <StaticImage
            className="h-full w-full"
            src="../../images/page/marketing/scientist-01.jpg"
            alt="Thomson Solutions At Work"
            placeholder="blurred"
            transformOptions={{
              duotone: { highlight: "#2473B3", shadow: "#003959", opacity: 75 },
            }}
          />
        </div>

        <div className="pb-8 pt-2.5 sm:pt-4 md:col-span-4">
          <H5 className="text-slate-300">{props.cta}</H5>
          <H2 className="text-white">{props.title}</H2>
          <P hero className="text-slate-300">
            {props.children}
          </P>
          <div className="mt-8 inline-block">
            <PageButton to="/form/contact" onClick={() => tag()} white>
              {props.button}
            </PageButton>
          </div>
        </div>
      </Section>
    </Block>
  )
}

const SeriesCTA = props => {
  return (
    <div
      className={twMerge([
        "shadow-inner",
        props.light ? "bg-white" : "bg-slate-800",
      ])}
    >
      <div
        className={twMerge([
          "mx-auto max-w-screen-xl px-4 py-16  sm:px-6 lg:px-8",
          props.more ? "sm:py-20" : "sm:py-24",
        ])}
      >
        <div
          className={twMerge([
            "",
            props.more
              ? "lg:grid lg:grid-cols-3 lg:gap-8"
              : "lg:grid lg:grid-cols-2 lg:gap-8",
          ])}
        >
          <h2
            className={twMerge([
              "mx-auto max-w-md text-center text-3xl font-extrabold leading-9 lg:max-w-xl lg:text-left ",
              props.light ? "text-slate-800" : "text-slate-100",
              props.more ? "col-span-1" : "",
            ])}
          >
            {props.title}
          </h2>
          <div
            className={twMerge([
              "mt-8 flow-root lg:mt-0",
              props.more ? "col-span-2" : "self-center",
            ])}
          >
            <div
              className={twMerge([
                props.more
                  ? "grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-4 lg:gap-8 xl:grid-cols-3"
                  : "grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-8 ",
              ])}
            >
              {props.children}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { SectionCTA, ContactCTA, SeriesCTA }
